import MarkdownEditor from "@/component/Markdown/MarkdownEditor";
import MarkdownPreview from "@/component/Markdown/MarkdownPreview";
import SpeakerAvatar from "@/pages/Voice/SpearkerAvatar";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySpeakerStore from "@/store/summarySpeaker.store";
import { ISpeakerSummary } from "@/types/summary";
import { getSpeakerAvatarInfo } from "@/utils/newAvatar";

const SpeakerSummaryItem: React.FC<{ info: ISpeakerSummary; avatarSrc: string; id?: string; index: number }> = ({ info, avatarSrc, id, index }) => {
  const summaryEditing = summaryCommonStore((state) => state.summaryEditing);
  const modifySpeakerSummary = summarySpeakerStore((state) => state.modifySpeakerSummary);
  const newSpeakerSummary = summarySpeakerStore((state) => state.newSpeakerSummary);
  const handleEditContent = (content: string) => {
    modifySpeakerSummary(
      newSpeakerSummary?.map((item, _index) => {
        if (index === _index) {
          return { ...item, content };
        }
        return item;
      }) || []
    );
    console.log("newSpeakerSummary?.map  newSpeakerSummary:", newSpeakerSummary);
  };
  const speakerAvatarInfo = getSpeakerAvatarInfo(info.headImage);

  return (
    <div className="flex flex-col select-text items-start">
      <div className="flex flex-row justify-center items-center mb-4">
        {info.headImage ? (
          <SpeakerAvatar
            speakerName={info.speakerName[0]}
            avatarIndex={speakerAvatarInfo.avatarIndex}
            useDefaultAvatarIcon={info.useDefaultIcon}
            className="size-6 rounded-full block"
            fontSize="0.56rem"
          />
        ) : (
          <img src={avatarSrc} className="size-6 rounded-full block" />
        )}
        <span className="font-400 font-size-3.5 color-#A1A7B2 text-center ml-2">{info.speakerName[0]}</span>
      </div>

      <div className="b-l-1 b-l-#ECEEF3 b-l-solid ml-1 pl-5 w-full color-#30343C text-3.5 font-normal text-justify select-text lh-7">
        {summaryEditing ? (
          <MarkdownEditor
            id={id}
            mode="wysiwyg"
            initialValue={info.content}
            onChange={handleEditContent}
          />
        ) : (
          <MarkdownPreview value={info.content} />
        )}
      </div>
    </div>
  );
};
export default SpeakerSummaryItem;
